var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 46,
    viewBox: "0 0 35 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_368_7102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.70932 0.675537L2.43652 9.00188L6.86043 19.3139L14.1278 14.9771L8.70932 0.675537Z",
    fill: "#0074FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.3195 0.675537L32.5862 9.00188L28.1684 19.3139L20.901 14.9771L26.3195 0.675537Z",
    fill: "#0074FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.4477 0.675537H8.70932V8.28314H26.4477V0.675537Z",
    fill: "#0074FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5815 45.5904C26.9704 45.5904 34.5815 37.993 34.5815 28.621C34.5815 19.2491 26.9704 11.6516 17.5815 11.6516C8.1927 11.6516 0.581543 19.2491 0.581543 28.621C0.581543 37.993 8.1927 45.5904 17.5815 45.5904Z",
    fill: "#0074FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.5815 43.16C25.6257 43.16 32.1469 36.6506 32.1469 28.6209C32.1469 20.5912 25.6257 14.0818 17.5815 14.0818C9.53732 14.0818 3.0162 20.5912 3.0162 28.6209C3.0162 36.6506 9.53732 43.16 17.5815 43.16Z",
    fill: "#FC8368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.1921 23.809C26.0632 21.665 23.3845 20.8366 21.2366 21.9634L19.1741 23.0476C19.3572 22.9502 19.7904 24.1805 19.8332 24.2963C19.943 24.5886 20.0711 24.8993 20.1016 25.216C20.1627 25.8982 19.4853 25.6119 19.2901 25.216C19.0216 24.6678 18.9301 24.0526 18.5518 23.5593C18.1795 23.072 17.728 22.6639 17.2948 22.2314C15.5801 20.5199 12.7732 20.5199 11.0586 22.2314C9.59411 23.6933 9.38664 25.953 10.424 27.6463L9.81378 27.9691C7.66589 29.0959 6.83603 31.7699 7.96489 33.9139C9.09375 36.0579 11.7725 36.8863 13.9204 35.7594L16.1354 34.5961C16.0255 34.4621 15.9096 34.3281 15.812 34.1758C15.5679 33.7982 14.9943 32.9515 15.1408 32.4764C15.2689 32.0622 15.7205 32.2206 15.9279 32.4886C16.1903 32.8419 16.294 33.3779 16.532 33.7677C17.2764 34.9859 18.5518 35.9726 19.9796 36.2224C21.3831 36.466 22.8597 36.0153 23.8665 35.0042C25.1968 33.6763 25.4897 31.6846 24.7513 30.0644L25.3493 29.7538C27.4972 28.6269 28.3271 25.953 27.1982 23.809H27.1921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.7542 8.28314L8.70932 0.675537",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.1404 8.28314L26.1792 0.675537",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_7102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 45,
    fill: "white",
    transform: "translate(0.581543 0.590332)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/기타.8b45f73c33f33c5a0e738be02b18f864.svg";
export { ForwardRef as ReactComponent };